import { render, staticRenderFns } from "./PedidoEntradasTable.vue?vue&type=template&id=ad2c4276"
import script from "./PedidoEntradasTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoEntradasTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports